import * as TrialActions from './trial.actions';

export interface State {
  trial: any;
  steps: any;
}

const initialState: State = {
  trial: null,
  steps: {
    audit: {
      url: null
    },
    payment: {
      url: null
    }
  }
};

export function trialReducer(state = initialState, action: TrialActions.TrialActions) {
  switch (action.type) {
    case TrialActions.SET_TRIAL_STEP_PARAM:
      const steps = state.steps;
      steps[action.payload.stepName][action.payload.paramName] = action.payload.value;
      return {
        ...state,
        steps: steps
      };
  }
  return state;
}
